__turbopack_context__.v({
  "actions": "vDHlYq_actions",
  "barWrapper": "vDHlYq_barWrapper",
  "bottomBar": "vDHlYq_bottomBar",
  "bottomLeft": "vDHlYq_bottomLeft",
  "bottomLeftSecondary": "vDHlYq_bottomLeftSecondary",
  "bottomRight": "vDHlYq_bottomRight",
  "content": "vDHlYq_content",
  "leftSideWrapper": "vDHlYq_leftSideWrapper",
  "loggedInUserContent": "vDHlYq_loggedInUserContent",
  "logo": "vDHlYq_logo",
  "logoLink": "vDHlYq_logoLink",
  "mainBarWrapper": "vDHlYq_mainBarWrapper",
  "navLinks": "vDHlYq_navLinks",
  "navigationButton": "vDHlYq_navigationButton",
  "rightIcon": "vDHlYq_rightIcon",
  "wrapper": "vDHlYq_wrapper",
});
